{
  "about_this_election": "Over deze verkiezing",
  "add_polling_stations_first": "De invoerfase kan pas gestart worden als er stembureaus zijn toegevoegd.",
  "add_the_date_and_time": "Voer de datum en tijd in waarop de zitting van het gemeentelijke stembureau officieel is geopend.",
  "add_the_location": "Vul de plaatsnaam in. Bijvoorbeeld <em>Amersfoort</em>",
  "alert_register": {
    "title": "Publieke sleutel registreren",
    "explanation": "Je moet de publieke sleutel van dit {committee} registreren. Doe dit door de sleutel te uploaden naar het overdrachtsplatform van Kiesraad. <strong>Doe dit uiterlijk twee dagen voor de dag van stemming.</strong>",
    "register": "Publieke sleutel registreren",
    "register_already_done": "Ik heb dit al gedaan"
  },
  "began_on": "Begon op",
  "committee_session_details": "Details van de zitting",
  "custom_committee_session_details": "Details van {sessionLabel}",
  "data_entry": "Invoer",
  "date": "Datum",
  "date_and_time_of_session_start": "Datum en tijdstip aanvang van {sessionLabel}",
  "date_error": "Vul de datum in als: dd-mm-jjjj",
  "date_hint": "dd-mm-jjjj, bijvoorbeeld 18-03-2026",
  "delete_session": "Zitting verwijderen",
  "delete_session_are_you_sure": "Weet je zeker dat je {sessionLabel} wilt verwijderen? Deze actie kan niet worden teruggedraaid.",
  "delete_investigations_first": "Verwijder eerst onderzoeken",
  "delete_investigations_first_are_you_sure": "Er zijn onderzoeken toegevoegd aan deze zitting. Verwijder eerst de onderzoeken voor je de zitting verwijdert.",
  "document_model": "Model",
  "document_n_10_1_and_n_10_2": "Processen-verbaal per stembureau",
  "document_n_10_1_inlegvel": "Inlegvellen controles en correcties per stembureau",
  "document_na_14_1_versie_1": "Corrigenda eerste zitting per stembureau",
  "document_na_31_1_inlegvel": "Inlegvel controles en correcties bij GSB proces-verbaal",
  "document_na_31_2_bijlage_1": "Verslagen van tellingen van stembureau",
  "document_na_31_2_inlegvel": "Inlegvel controles en correcties",
  "document_purpose": "Doel",
  "finish_data_entry": {
    "about_to_stop_data_entry": "Je staat op het punt het invoeren van stemmen te stoppen.",
    "explanation": {
      "GSB": "<ul><li>In de volgende stap kan je het proces-verbaal van deze zitting opmaken en de officiële telbestanden downloaden.</li><li>Zolang er geen volgende zitting is gestart, kan je nog terug naar de invoer.</li></ul>",
      "CSB": "<ul><li>In de volgende stap ga je verder met de zetelverdeling. Daarna kan je het proces-verbaal voor de zitting van het centraal stembureau opmaken en de officiële bestanden downloaden.</li></ul>"
    }
  },
  "GSB": {
    "download_definitive_documents": "Download definitieve documenten {sessionLabel}",
    "download_definitive_files": "Download de definitieve bestanden.",
    "first_session": {
      "documents": "<li><strong>PDF-document met het proces-verbaal.</strong> Dit wordt tijdens de zitting van het gemeentelijk stembureau vastgesteld en ondertekend.</li><li><strong>EML- en CSV-bestanden met digitale telresultaten, en een digitale handtekening van het EML-bestand.</strong></li>"
    },
    "next_session": {
      "with_corrections": {
        "documents": "<li><strong>Het proces-verbaal van het gemeentelijk stembureau (P 2a). Dit is een PDF-document.</strong> Dit wordt tijdens de zitting van het gemeentelijk stembureau vastgesteld en ondertekend.</li><li><strong>Het corrigendum van het gemeentelijk stembureau (Na 14-2). Dit is een PDF-document.</strong> Bevat de gecorrigeerde telresultaten van de gemeente.</li><li><strong>EML- en CSV-bestanden met digitale telresultaten, en een digitale handtekening van het EML-bestand.</strong></li>"
      },
      "without_corrections": {
        "documents": "<li><strong>Het proces-verbaal van het gemeentelijk stembureau (P 2a). Dit is een PDF-document.</strong> Dit wordt tijdens de zitting van het gemeentelijk stembureau vastgesteld en ondertekend.</li>"
      }
    },
    "upload_the_zip": "Upload het volledige ZIP-bestand naar het overdrachtsplatform."
  },
  "CSB": {
    "download_definitive_documents": "Definitieve documenten",
    "download_definitive_files": "Download de ZIP-bestanden.",
    "download_explanation": "Hierin zitten de volgende documenten:",
    "determination_election_results": {
      "download": "Vaststelling uitslag",
      "explanation_text": "<li>Proces-verbaal model P 22-2</li><li>EML_NL-telbestand 520 met zetelverdeling</li>"
    },
    "p_22_2_attachment": {
      "download": "Model P 22-2 Bijlage 1",
      "explanation_text": "<li>Bijlage 1 van proces-verbaal P 22-2 met tellingen per lijst en kandidaat</li>"
    },
    "definitive_documents": {
      "download": "Definitieve documenten",
      "explanation_text": "<li>EML_NL-telbestand 510d met totaaltelling van de gemeente</li><li>CSV met totaaltelling</li>"
    },
    "upload_the_zip": "Upload alle ZIP-bestanden naar het overdrachtsplatform."
  },
  "electoral_area": "Kiesgebied",
  "empty_document_description": {
    "singular": "Onderstaand model is relevant voor de huidige zitting van het gemeentelijk stembureau. Overige modellen zijn te downloaden via de toolkit van de Kiesraad.",
    "plural": "Onderstaande modellen zijn relevant voor de huidige zitting van het gemeentelijk stembureau. Overige modellen zijn te downloaden via de toolkit van de Kiesraad."
  },
  "empty_document_next_session": {
    "singular": "Leeg inlegvel voor deze verkiezing",
    "plural": "Lege inlegvellen voor deze verkiezing"
  },
  "empty_documents_first_session": "Lege processen-verbaal voor deze verkiezing",
  "enter_a_number": "Voer een getal in",
  "enter_number_of_voters": "Voer het aantal kiesgerechtigden voor deze verkiezing in zoals door de burgemeester en wethouders aan het gemeentelijk stembureau is doorgegeven.",
  "how_many_voters": "Hoeveel kiesgerechtigden telt het GSB?",
  "if_gsb_correction": "Wil het gemeentelijk stembureau zelf een fout herstellen en is de zitting nog niet afgesloten door de voorzitter? Ga dan verder in de eerste zitting.",
  "import_sub_committee_keys": "Publieke sleutels GSB's importeren",
  "investigation_ordered_by_csb": "Onderzoek in opdracht van het CSB?",
  "lists_and_candidates": "Lijsten en kandidaten",
  "missing_committee_session_details_modal": {
    "ask_coordinator": "Vraag de coördinator om de details van de zitting in te vullen.",
    "content": "Op het corrigendum worden de plaats en tijd van de zitting weergegeven. Deze zijn nog niet ingevuld. Om het corrigendum te kunnen gebruiken, moeten deze gegevens eerst ingevuld worden.",
    "enter_details_button": "Details invullen",
    "title": "Vul eerst de details van de zitting in"
  },
  "no_polling_stations": "Geen stembureaus",
  "only_add_if_ordered": "Voeg alleen een nieuwe zitting toe als het centraal stembureau hier opdracht voor heeft gegeven.",
  "prepare_new_session": "Nieuwe zitting voorbereiden",
  "requested_investigations": "Aangevraagde onderzoeken",
  "results_and_documents": "Resultaten en documenten",
  "resume_or_check_progress": "Hervatten of voortgang bekijken",
  "select_polling_stations": "Selecteer stembureaus",
  "session_location": "Plaats van de zitting",
  "session_start": "Start van de zitting",
  "start_data_entry": "Start invoer",
  "stay_in_data_entry_phase": "In invoerfase blijven",
  "time": "Starttijd",
  "time_error": "Vul de tijd in als: uu:mm",
  "time_hint": "uu:mm, bijvoorbeeld 09:34",
  "to_report": "Naar proces-verbaal",
  "view_data_entry": "Invoer bekijken",
  "view_investigations": "Bekijk onderzoeken",
  "what_now": "Wat nu",
  "yes_add_session": "Ja, zitting toevoegen",
  "yes_delete_session": "Verwijder zitting",
  "zip_file": "ZIP-bestand",
  "zip_file_explanation": "In het ZIP-bestand zitten de volgende documenten:"
}
